import React from "react";
import cn from "helpers/classnames";

const Loader = ({ className }) => {
  return <div className={cn("lc-loader", className)} />;
};

export default Loader;
